export enum LangueEnum {
  FR = 'fr',
  EN = 'en',
}
export default LangueEnum;
